import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SetupPage from "./pages/SetupPage";
import InvitePage from "./pages/InvitePage";
import LobbyPage from "./pages/LobbyPage";
import GuestJoin from "./pages/GuestJoin";
import SwipePage from "./pages/SwipePage";
import MatchPage from "./pages/MatchPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <>
      <div className="global-backdrop" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/invite/:sessionId" element={<InvitePage />} />
          <Route path="/lobby/:sessionId" element={<LobbyPage />} />
          <Route path="/join/:sessionId" element={<GuestJoin />} />
          <Route path="/swipe/:sessionId" element={<SwipePage />} />
          <Route path="/match/:sessionId" element={<MatchPage />} />
          {/* Legacy routes for backward compatibility */}
          <Route path="/share/:sessionId" element={<InvitePage />} />
          <Route path="/waiting/:sessionId" element={<LobbyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </>
  );
}

export default App;
